import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Body, SubmitButton, FormCadastro, GroupField, Field, PageHeader, InputDisabled } from '@components';
import { getVariavelAmbiente, putVariavelAmbiente, reset } from '@ducks/indicadoresVariaveisAmbiente';
import * as TiposVariaveis from './TiposVariaveis';
import App from '@app';

export default function Edicao() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { idCliente, idInformacao } = useParams();

  const variavelAmbiente = useSelector(({ indicadoresVariaveisAmbiente }) => indicadoresVariaveisAmbiente.get('variavelAmbiente'));
  const valoresSelecionados = useSelector(({ indicadoresVariaveisAmbiente }) => indicadoresVariaveisAmbiente.get('valoresSelecionados'));
  const successVariavelAmbiente = useSelector(({ indicadoresVariaveisAmbiente }) =>
    indicadoresVariaveisAmbiente.get('successVariavelAmbiente')
  );
  const successPutVariavelAmbiente = useSelector(({ indicadoresVariaveisAmbiente }) =>
    indicadoresVariaveisAmbiente.get('successPutVariavelAmbiente')
  );

  useEffect(() => {
    dispatch(getVariavelAmbiente(idCliente, idInformacao));
  }, []);

  useEffect(() => {
    if (successVariavelAmbiente) form.setFieldsValue(variavelAmbiente);
  }, [successVariavelAmbiente]);

  useEffect(() => {
    if (successPutVariavelAmbiente) {
      dispatch(reset());
      history.goBack();
    }
  }, [successPutVariavelAmbiente]);

  const handleSubmit = (data) => {
    const object = { idCliente, idInformacao, expressao: valoresSelecionados.toString() };

    dispatch(putVariavelAmbiente(object));
  };

  function handleTpVariavel() {
    if (!successVariavelAmbiente) return;

    switch (variavelAmbiente.tp) {
      case TiposVariaveis.Types.SELECT_TABLE:
        return <TiposVariaveis.SelectTable data={variavelAmbiente} />;
      default:
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title="Variável de Ambiente" onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <Field label="Variável" name="variavel">
                <InputDisabled disabled />
              </Field>
              {handleTpVariavel()}
            </GroupField>
            <SubmitButton type="success" htmlType="submit" block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
